module.exports = "<ion-item class=\"item-text-wrap\"\n          ng-class=\"{'item-icon-right': $ctrl.iconRight != null}\">\n\n    <h3 class=\"padding-bottom\">\n        {{::$ctrl.customer.title}} {{::$ctrl.customer.name}}\n    </h3>\n\n    <div class=\"row row-condensed text-light\">\n        <div class=\"col\">\n            {{::$ctrl.customer.number}}\n        </div>\n    </div>\n\n    <i ng-if=\"::$ctrl.iconRight\" class=\"icon\" ng-class=\"$ctrl.iconRight\"></i>\n</ion-item>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/customer-item/customer-item.html
// module id = 886
// module chunks = 0